import type { PmMarkConverter } from './../pm-converters/types';
import type { AnchorData } from './../ricos-schema/legacy/wix/rich_content/v1';
import { Decoration_Type } from './../ricos-schema/legacy/wix/rich_content/v1';

export const anchorConverter: PmMarkConverter = {
  fromPm: {
    type: Decoration_Type.ANCHOR,
    convert: mark => {
      const { attrs } = mark;
      return [
        {
          type: Decoration_Type.ANCHOR,
          anchorData: { ...attrs } as AnchorData,
        },
      ];
    },
  },
  toPm: {
    type: Decoration_Type.ANCHOR,
    convert: decoration => {
      const { anchorData } = decoration;
      return {
        type: Decoration_Type.ANCHOR,
        attrs: { ...anchorData },
      };
    },
  },
};
